import BaseView from "scripts/views/baseView";
import templatePager from "templates/pager.hbs";

class PagerView extends BaseView {
  get template() {
    return templatePager;
  }

  get events() {
    return {
      "click .bb-pager-view-first-page-link": "onClickFirstPage",
      "click .bb-pager-previous-page-link": "onClickPreviousPage",
      "click .bb-pager-next-page-link": "onClickNextPage",
      "keyup #bb-pager-view-page-go-field": "onKeyupPageGo",
    };
  }

  constructor(options) {
    super(options);

    this.mediaView = this.addSubView(options.mediaView);

    this.pageNumber = options.pageNumber;
    this.totalPages = options.totalPages;
    this.hasPreviousPage = options.hasPreviousPage;
    this.hasNextPage = options.hasNextPage;
  }

  render() {
    this.$el.html(
      this.template({
        hasPreviousPage: this.hasPreviousPage,
        hasNextPage: this.hasNextPage,
        pageNumber: this.pageNumber,
        totalPages: this.totalPages,
      }),
    );

    this.mediaView
      .appendTo(this.$el.find(".bb-pager-media-view-region"))
      .render();

    return this;
  }

  onKeyupPageGo(e) {
    if (e.which === 13) {
      const $input = $(e.currentTarget);
      const pageSequence = parseInt($input.val(), 10);

      if (
        !isNaN(pageSequence) &&
        pageSequence > 0 &&
        pageSequence <= this.totalPages
      ) {
        this.trigger("pageSequenceChanged", pageSequence);
      } else {
        $input.val(this.pageNumber);
      }
    }

    return false;
  }

  onClickFirstPage() {
    this.trigger("pageSequenceChanged", 1);
  }

  onClickNextPage() {
    this.trigger("pageSequenceChanged", this.pageNumber + 1);
  }

  onClickPreviousPage() {
    this.trigger("pageSequenceChanged", this.pageNumber - 1);
  }
}

export default PagerView;
